"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";
import { Messages } from "Messages";

var BlankControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(BlankControl, _BaseControl);

  function BlankControl(props) {
    var _this;

    _classCallCheck(this, BlankControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlankControl).call(this, props));

    _this.$_element.addClass('blank-field');

    if (typeof _this.props.onValueChanged === 'function') {
      _this.props.onValueChanged({
        value: null
      });
    }

    return _this;
  }

  _createClass(BlankControl, [{
    key: "dispose",
    value: function dispose() {
      this.$_element.remove();
    }
  }, {
    key: "setValue",
    value: function setValue(newValue) {}
  }, {
    key: "getValue",
    value: function getValue() {
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element.text(Messages.Controls.IsBlank);
    }
  }]);

  return BlankControl;
}(BaseControl);

export { BlankControl as default };